export const B2C_COLORS = {
	PRIMARY: "#13c892",
	SLEEP: "#13c892",
	TRANSPORT: "#ea5681",
	SEE_DO: "#ffc14a",
	EAT_DRINK: "#6237dd",
};

export const B2B_COLORS = {
	PRIMARY: "#1b3d49",
	SLEEP: "#818cf8",
	TRANSPORT: "#7c3aed",
	SEE_DO: "#00d4aa",
	EAT_DRINK: "#e979f9",
};

export const DEFAULT_B2B_THEME = {
	BRAND_PRIMARY: B2B_COLORS.PRIMARY,
	BRAND_SECONDARY: B2B_COLORS.SEE_DO,
};
